import React, {
  useState,
  useEffect,
  useRef
} from 'react';
import './ReleaseCalendar.css';

import Navbarr from '../../components/header/Navbarr';
import Googleadshorizontal from '../../components/google-AdSense/Googleadshorizontal';
import Subheader from '../../components/subheader/Subheader';
import { Footer } from '../../components/footer/footer';
import ScrollButton from '../../components/scrollbutton/ScrollButton';
import MovieComponent from '../../components/shared/MovieComponent';
import { moviefilterPost } from '../../api/handleapi';
import { Errormsg } from '../../components/tostifymsg/Errrormsg';

function ReleaseCalendar() {
  const [optionItem, setOptionItem] = useState('upcommingAndPending');
  const [search, setSearch] = useState('');
  
  const [moviesAll, setMoviesAll] = useState([]);
  const [visibleMovies, setVisibleMovies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [moviesLimit, setMoviesLimit] = useState(5);
  const loader = useRef(null);


  useEffect(() => {
    let isMounted = true;

    moviesSections(isMounted);

    return () => {
      isMounted = false;
    };
  }, [optionItem]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loadMore();
        }
      },
      { threshold: 1 }
    );

    if (loader.current) {
      observer.observe(loader.current);
    }

    return () => {
      if (loader.current) {
        observer.unobserve(loader.current);
      }
    };
  }, [visibleMovies]);

  const moviesSections = async (isMounted) => {
    try {
      const { data: { data: movies } } = await moviefilterPost({
        ReleaseType: optionItem
      });

      if (isMounted) {
        setMoviesAll(movies);
        setVisibleMovies(movies.slice(0, moviesLimit));
      }
    } catch (error) {
      Errormsg(error?.response?.data?.message);
    } finally {
      if (isMounted) {
        setLoading(false);
      }
    }

  }

  const loadMore = () => {
    if (visibleMovies.length >= moviesAll.length) {
      return;
    }

    const nextCount = moviesLimit + 20;

    setVisibleMovies(moviesAll.slice(0, nextCount));
    setMoviesLimit(nextCount);
  };

  return (
    <div>
      <Navbarr/>

      <div className="after-nav-dsubheader containers con_div">
        <Googleadshorizontal props="mt-2 mb-2 text-center"/>
        <Subheader />

        <div className='content-release-calendar'>
          <h3 className='text-center font-weight-bold'>Release Calendar</h3>

          <div className='d-flex justify-content-center mt-4 mb-4'>
            <div className='input-group search-box'>
              <input type="text" placeholder='Search' value={search} onChange={(e) => setSearch(e.target.value)} />
              
              <span><i className='fa fa-search'></i></span>
            </div>
          </div>

          <div className='content-options d-flex justify-content-center mb-4'>
            <label className={`option-item ${optionItem === 'upcommingAndPending' ? 'option-item-active' : ''}`} for='release-status-upcommingAndPending'>
              <input className='d-none' type="radio" name='release-status' value='upcommingAndPending' id='release-status-upcommingAndPending' onChange={() => setOptionItem('upcommingAndPending')} checked={optionItem === 'upcommingAndPending'}/> 
              { optionItem === 'upcommingAndPending' && (
                <span>
                  <i className='fa fa-check'></i>
                </span>
              ) }
              All 
            </label>
            <label className={`option-item ${optionItem === 'upcoming' ? 'option-item-active' : ''}`} for='release-status-upcoming'>
              <input className='d-none' type="radio" name='release-status' value='upcoming' id='release-status-upcoming' onChange={() => setOptionItem('upcoming')} checked={optionItem === 'upcoming'}/>
              { optionItem === 'upcoming' && (
                <span>
                  <i className='fa fa-check'></i>
                </span>
              ) }
              Upcoming
            </label>
            <label className={`option-item ${optionItem === 'pending' ? 'option-item-active' : ''}`} for='release-status-pending'>
              <input className='d-none' type="radio" name='release-status' value='pending' id='release-status-pending' onChange={() => setOptionItem('pending')} checked={optionItem === 'pending'}/>
              { optionItem === 'pending' && (
                <span>
                  <i className='fa fa-check'></i>
                </span>
              ) }
              Pending
            </label>
          </div>

          <div className='movies-sections'>
            
            <div className='content-movie mb-4'>
              <div className="row">
                { !search && visibleMovies.map((movie, i) => (
                  <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12" key={i}>
                    <MovieComponent
                      name={movie.name}
                      poster={movie.poster}
                      id={movie.id}
                    />
                  </div>
                ))}

                { search && moviesAll.filter(movie => movie.name.toLowerCase().includes(search.toLowerCase())).map((movie, i) => 
                  <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12" key={i}>
                    <MovieComponent
                      name={movie.name}
                      poster={movie.poster}
                      id={movie.id}
                      releaseDate={movie.releaseDate}
                    />
                  </div>
                )}
              </div>
            </div>

            <div ref={loader} className='mt-4 mb-4 text-center'>
              {loading && <p>Cargando...</p>}
              
              {!loading && visibleMovies.length < moviesAll.length && (
                <p>Desplázate para ver más...</p>
              )}
            </div>
          </div>  
        </div>
      </div>

      <Footer />
      <ScrollButton />
    </div>
  );
}

export default ReleaseCalendar;